import React from "react";

function Loading() {
  return <div className="text-2xl font-montserrat">Loading . . .</div>;
}

export default Loading;
